import React from 'react';

function Footer() {
    return (
        <footer style={footerStyle}>
            <div style={containerStyle}>
                <div style={textCenter}>
                    <p style={textMuted}>
					  © {new Date().getFullYear()}{' '}
					  <a href="https://digitalforge.qa" style={{ color: '#6c757d', textDecoration: 'none' }}>
						Digital Forge Information Technology
					  </a>
					</p>
                </div>
            </div>
        </footer>
    );
}

// Inline styles
const footerStyle = {
    marginTop: 'auto',
    padding: '20px 0',
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #ddd',
    color: '#6c757d',
    fontSize: '0.9rem',
    position: 'relative',
    bottom: 0,
    width: '100%'
};

const containerStyle = {
    maxWidth: '1140px',
    margin: '0 auto',
    padding: '0 15px'
};

const textCenter = {
    textAlign: 'center'
};

const textMuted = {
    margin: 0,
    lineHeight: '1.5'
};

export default Footer;
